var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-popup-board"},[_c('Popup',{attrs:{"placement":_vm.placement,"active":_vm.active,"target":_vm.target},on:{"onClose":_vm.onClose}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }